import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';
import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';

import { useTranslationWithPrefix } from '@hotjar/translations';
import { SiteListAction } from './SiteListAction';

interface SiteDeleteIconProps {
  isOwner: boolean;
  isAdmin: boolean;
  sitePlans: (FeatureGroup | null)[];
  sitesTotal: number;
  isMobile: boolean;
  onClick(): void;
}

export const SiteDeleteIcon = ({
  isOwner,
  isAdmin,
  sitePlans,
  sitesTotal,
  isMobile,
  onClick,
}: SiteDeleteIconProps): ReactElement => {
  const { t } = useTranslationWithPrefix('account:sites-and-organizations.site.actions.delete');

  const [tooltip, setTooltip] = useState(t<string>('allowed'));
  const [isDisabled, setIsDisabled] = useState(false);
  const hasPaidPlans = sitePlans.some((sitePlan) => sitePlan !== 'basic');

  useEffect(() => {
    if (sitesTotal === 1) {
      setTooltip(t('not-allowed.only-one-site'));
      setIsDisabled(true);
    } else if (hasPaidPlans) {
      const tooltipText = t(
        isOwner ? 'not-allowed.not-basic-owner' : 'not-allowed.not-basic-non-owner',
      );
      setTooltip(tooltipText);
      setIsDisabled(true);
    }
  }, [sitesTotal, hasPaidPlans, t, isOwner]);

  return (
    <SiteListAction
      text={t('allowed')}
      tooltipText={tooltip}
      icon="trash"
      isDisabled={isDisabled}
      isAdmin={isAdmin}
      isMobile={isMobile}
      onClick={onClick}
    />
  );
};
